/* eslint-disable max-len */
export default {
  ACTIONS: {
    HOME: 'Inizio',
    LOGOUT: 'Termina sessione',
    NEXT: 'Prossimo',
    SUBMIT: 'Invio',
    USERS: 'Utenti'
  },
  ERRORS: {
    BASE:
      'Qualcosa è andato storto...Ci dispiace! Si prega di riprovare tra qualche minuto. 🥴'
  },
  MESSAGES: {
    NOT_FOUND: 'Pagina non trovata',
    ORDER: 'Ordine',
    OTHER: 'Altro',
    OTHER_RET: 'Altro...',
    PROZIS_NOW: 'PROZIS NOW',
    UNAUTHORIZED: 'Non è possibile accedere'
  },
  SENTENCES: {
    NOT_FOUND: 'Non è stato possibile trovare ciò che cerchi.',
    UNAUTHORIZED:
      'Non hai il permesso di accedere, se hai bisogno di farlo, si prega di contattarci.'
  }
};
